import { render } from "./Home.vue?vue&type=template&id=aa18c354"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import exportComponent from "/home/josearpaia/Documentos/etyalab/cositas-en-vue/api-banderas-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__